export default __webpack_public_path__ + "static/media/ico_arrow_back.0841bae6.svg";